'use strict';

var $ = require('jquery');
const anime = require('animejs');

$(function() {
    var animatedperson = document.querySelectorAll('.animated-article-first');
    // initialization
    var city = $('.city-details');
    var button = $('.city-button');
    var firstcity = $('.data-filter-1');
    var firstbutton = $('.city-filter-1');
    function cityfilter(){
        city.hide();
        firstcity.show();
        firstbutton.addClass('active-filter');
    }
    cityfilter();
    // filtering
    button.click(function() {

        if ($(window).width() < 768) {
            $(document).scrollTop( $("#contacts").offset().top - 100 );
        }

        button.removeClass('active-filter');
        city.hide();
        var data = $(this).attr("data-filter");
        $(this).addClass('active-filter');
        $('.' + data).fadeIn(300);
    });
});